import React, { useState, useEffect, useContext, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { Tooltip, Breadcrumb, Button, BreadcrumbItem, Tile, Tag, Link, OverflowMenuItem, OverflowMenu, Form, Modal, InlineNotification, NotificationActionButton, TextInput } from 'carbon-components-react'
import Toast from '../../components/Notification/Toast'
import AuthContext from '../../context/AuthContext'
import 'react-quill/dist/quill.snow.css';
import 'suneditor/dist/css/suneditor.min.css'; // Import Sun Editor's CSS File
import { normalizePhone, deNormalizePhone } from '../../utils/functions/tools/normalizePhone';

const { REACT_APP_DEV_API_URL, REACT_APP_PROD_API_URL, NODE_ENV } = process.env;
const API_URL =
    NODE_ENV === 'production' ? process.env.REACT_APP_PROD_API_URL : process.env.REACT_APP_DEV_API_URL;

const SITE_URL =
    NODE_ENV === 'production' ? process.env.REACT_APP_PROD_MEDIA_URL : process.env.REACT_APP_DEV_MEDIA_URL;

const SubmissionShell = ({ match }) => {

    let { authTokens } = useContext(AuthContext)

    const [list, setList] = useState([]);
    const [editorContent, setEditorContent] = useState('')
    let toastProperties = null;

    //assigning location variable
    const location = useLocation();

    //destructuring pathname from location
    const { pathname } = location;

    //Javascript split method to get the name of the path in array
    const splitLocation = pathname.split("/");

    // Variables for modals and toasts
    const [error, setError] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [editContactID, setEditContactID] = useState(false);
    const [openEditAgreementModal, setOpenEditAgreementModal] = useState(false);

    // Variables for noteSeaarch
    let [client, setClients] = useState(null)

    // Other Variables
    let profileId = match.params.id
    let [page, setPage] = useState(null)

    useEffect(() => {
        getSubmission()
        document.title = "Submission Details | WillowBMS"
        setPage(splitLocation[2])
    }, [profileId, editContactID])

    useEffect(() => {
        setPage(splitLocation[2])
    })

    let downloadSubmission = async () => {
        let response = await fetch(`${API_URL}/submissions/download/${profileId}/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authTokens?.access
            }
        }).then(response => response.blob()).then((file) => {
            const url = URL.createObjectURL(file);
            // create <a> tag dinamically
            var fileLink = document.createElement('a');
            fileLink.href = url;
            fileLink.target = "_blank";

            // it forces the name of the downloaded file
            fileLink.download = 'signed-agreement-' + client.fname + "_" + client.lname + '.pdf';

            // triggers the click event
            fileLink.click();
        }).catch((error) => {
            console.log('There has been a problem with your fetch operation: ' + error.message);
        });
    }

    let getSubmission = async () => {
        let response = await fetch(`${API_URL}/submissions/${profileId}/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authTokens?.access
            }
        })
        let data = await response.json()
        setClients(data)
        setEditorContent(data.content)
    }

    const showToast = (type, title, description) => {
        const id = Math.floor((Math.random() * 100) + 1);
        const time = new Date().toLocaleString();

        switch (type) {
            case 'success':
                toastProperties = {
                    id,
                    title: title,
                    description: description,
                    kind: 'success',
                    time: time
                }
                break;
            case 'error':
                toastProperties = {
                    id,
                    title: title,
                    description: description,
                    kind: 'error',
                    time: time
                }
                break;
            case 'info':
                toastProperties = {
                    id,
                    title: title,
                    description: description,
                    kind: 'info',
                    time: time
                }
                break;
            case 'warning':
                toastProperties = {
                    id,
                    title: title,
                    description: description,
                    kind: 'warning',
                    time: time
                }
                break;
            default:
                setList([]);
        }
        setList([...list, toastProperties]);
    }

    return (
        <div className="bms-page">
            {client &&
                <>
                    <Toast toastList={list} />
                    <div className="mb-2">
                        <Breadcrumb>
                            <BreadcrumbItem href="/submissions">Submissions</BreadcrumbItem>
                            <BreadcrumbItem href={`/submissions/${client.id}`}>{client.fname + ' ' + client.lname}</BreadcrumbItem>
                            <span>Details</span>
                        </Breadcrumb>
                    </div>
                    <div>
                        <div className="w-full summary-header">
                            <Tile><strong className="d-flex">#{client.id} - {client.fname} {client.lname}</strong></Tile>
                            <Tile light={true} className="w-full d-flex" style={{ minHeight: 0 }}>
                                <div className="col-6">
                                    <strong className="lh-27 d-flex">Contact Information</strong>
                                </div>
                                <div className="col-6 d-flex">
                                    <div className="ml-auto">
                                    </div>
                                </div>
                            </Tile>
                        </div>
                        <div className="summary-body">
                            <Tile light={true} className="row w-full d-flex flex-w">
                                <div className="col-12 col-md-6 p-05">
                                    <div className="mb-05">
                                        <strong>ID:</strong> <span className="">{client.id}</span>
                                    </div>
                                    <div className="mb-05">
                                        <strong>Full Name:</strong> <span className="">{client.fname} {client.lname}</span>
                                    </div>
                                    <div className="mb-05">
                                        <strong>Entity Name:</strong> <span className="">{client.entityname}</span>
                                    </div>
                                    <div className="mb-05">
                                        <strong>Email:</strong> <span className=""><Link href={`mailto:${client.email}`}>{client.email}</Link></span>
                                    </div>
                                    <div className="mb-05">
                                        <strong>Phone Number:</strong> <span className=""><Link href={`tel:${client.phone}`}>{normalizePhone(client.phone)}</Link></span>
                                    </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-6 p-05">
                                    <div className="mb-05">
                                        <strong>Address:</strong> <span className="">{client.street}</span>
                                    </div>
                                    {client.street2 != "" &&
                                        <div className="mb-05">
                                            <span className="pl-4">{client.street2}</span>
                                        </div>
                                    }
                                    <div className="mb-05">
                                        <span className="pl-4">{client.city}</span>, <span>{client.state}</span> <span>{client.postalcode}</span>
                                    </div>
                                    <div className="mb-05">
                                        <span className="pl-4">{client?.country != null ? client?.country : client.country}</span>
                                    </div>
                                </div>
                            </Tile>
                        </div>
                        <div className="w-full summary-footer">
                            <Tile light={true} className="w-full d-flex" style={{ minHeight: 0 }}>
                                <div className="col-6">
                                    
                                </div>
                                <div className="col-6 d-flex">

                                </div>
                            </Tile>
                        </div>
                    </div>
                    <div>
                        <div className="w-full summary-header">
                            <Tile light={true} className="w-full d-flex mt-2" style={{ minHeight: 0 }}>
                                <div className="col-6">
                                    <strong className="lh-27 d-flex">Property Submission Information</strong>
                                </div>
                                <div className="col-6 d-flex">
                                    <div className="ml-auto d-flex">
                                        <Button onClick={() => downloadSubmission()}>
                                            Download
                                        </Button>
                                    </div>
                                </div>
                            </Tile>
                        </div>
                        <div className="summary-body">
                            <Tile light={true} className="row w-full d-flex flex-w">
                                <div className="col-12 col-md-6 p-05">
                                    <div className="mb-05">
                                        <strong>Agreement Type ID:</strong> <span className=""><Link href={`${SITE_URL}/agreements/${client.type}/`}>{client.type}</Link></span>
                                    </div>
                                    <div className="mb-05">
                                        <strong>Signed Date/Time:</strong> <span className="">{client.signeddate}</span>
                                    </div>
                                    <div className="mb-05">
                                        <strong>IP Address:</strong> <span className="">{client.ipaddress}</span>
                                    </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-6 p-05">
                                    <div className="mb-05">
                                        <strong>Address:</strong> <span className="">{client.propertystreet}</span>
                                    </div>
                                    {client.street2 != "" &&
                                        <div className="mb-05">
                                            <span className="pl-4">{client.propertystreet2}</span>
                                        </div>
                                    }
                                    <div className="mb-05">
                                        <span className="pl-4">{client.propertycity}</span>, <span>{client.propertystate}</span> <span>{client.propertypostalcode}</span>
                                    </div>
                                    <div className="mb-05">
                                        <span className="pl-4">{client?.propertycountry != null ? client?.propertycountry : client.propertycountry}</span>
                                    </div>
                                </div>
                            </Tile>
                        </div>
                        <div className="w-full summary-footer">
                            <Tile light={true} className="w-full d-flex" style={{ minHeight: 0 }}>
                                <div className="col-6">
                                    
                                </div>
                                <div className="col-6 d-flex">

                                </div>
                            </Tile>
                        </div>
                    </div>
                </>
            }
        </div>
    )
}

export default SubmissionShell